import React from 'react';
import PatientForm from './patientForm';

const AddPatientPage = ({navigateTo}) => (
  <div>
    <PatientForm navigateTo={navigateTo} />
  </div>
);

export default AddPatientPage;
